module.exports = __webpack_public_path__ + "img/01_Certificaciones_ISO_2019.537aa296.jpg";